import React from 'react';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';

interface Issue {
  id?: number | string;
  type?: string;
  severity?: string;
  description?: string;
  location?: string;
  impact?: string;
  recommendation?: string;
}

interface IssueDetailsProps {
  open: boolean;
  issue?: Issue | null;
  onClose: () => void;
}

const IssueDetails: React.FC<IssueDetailsProps> = ({ open, issue, onClose }) => {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 420, p: 3 }}>
        <Typography variant="h6">Issue Details</Typography>
        <Divider sx={{ my: 2 }} />

        {!issue ? (
          <Typography color="textSecondary">No issue selected</Typography>
        ) : (
          <Box>
            <Typography variant="subtitle1" gutterBottom>{issue.type} — {issue.severity}</Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>{issue.location}</Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>{issue.description}</Typography>

            {issue.impact && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2">Impact</Typography>
                <Typography variant="body2">{issue.impact}</Typography>
              </Box>
            )}

            {issue.recommendation && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2">Recommendation</Typography>
                <Typography variant="body2">{issue.recommendation}</Typography>
              </Box>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={onClose}>Close</Button>
            </Box>
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

export default IssueDetails;
